var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"c-404"},[_c('div',{staticClass:"c-404__body"},[_c('app-intro',[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("Pagina niet gevonden")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }